import * as React from 'react';
import { Route, Switch} from 'react-router';
import Layout from './components/Layout';
import Home from './components/Home';
import ManageAccounts from "./components/pages/ManageAccounts";
import { JsonServiceClient } from '@servicestack/client';
import ContributionDetails from "./components/pages/ContributionDetails";
import { AppState } from './store/configureStore';
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { helperActionCreators } from './store/HelperStore';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import Logout from './components/pages/Logout';
import ContributionSchedulePayment from "./components/pages/ContributionSchedulePayment";
import ContributionHistory from "./components/pages/ContributionHistroy"
import ProtectedRoute from './components/ProtectedRoute';
import ContributionCancelPayment from './components/pages/ContributionCancelPayment';
import { stateLoading } from './functions/stateLoading';
import PageNotFound from './components/PageNotFound';
import ContactUs from './components/pages/ContactUs';

export const client = new JsonServiceClient(process.env.REACT_APP_API_URL);

client.requestFilter = req => {

    const contextToken = sessionStorage.getItem("CM.ContextToken");
    if (contextToken) {
        const initialHeaders: HeadersInit | undefined = req.headers
        const headers = new Headers(initialHeaders)
        headers.append("Wespath-Context-Token", contextToken)
        req.headers = headers
    }
}

export enum Path {
    ManageAccounts = "/manageaccounts",
    ContributionDetails = "/contributiondetails",
    ContributionHistory = "/contributionhistory",
    Logout = "/logout",
    ContributionSchedulePayment = "/ContributionSchedulePayment",
    ContributionCancelPayment = "/ContributionCancelPayment",
    SSO = "/sso",
    Default = "/",
    ContactUs = "/contactus"
}


type TAppProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const App = (props: TAppProps) => {

    const { pathname } = props;
  
    const [currentPage, setCurrentPage] = useState('');

    useEffect(() => {
       
        setCurrentPage(pathname);
    }, [pathname, currentPage, setCurrentPage])

    useEffect(() => {
        if (stateLoading(props.helper)) {
            props.fetchAllConfiguration();
        }

        switch (pathname) {
            case Path.ManageAccounts:
                document.title = "Manage Account";
                break;
            case Path.Logout:
                document.title = "Logout";
                break;
            case Path.ContributionHistory:
            case Path.ContributionDetails:
            case Path.ContributionCancelPayment:
            case Path.ContributionSchedulePayment:
            case Path.ContactUs:
                document.title = "Manage Contributions";
                break;
            default:
                document.title = "Contribution Management";
                break;
        }

    });

    return (
        <>
        <Layout>
            <Switch>
                <ProtectedRoute exact path={Path.Default} />
                <Route path={Path.SSO} component={Home} />
                <ProtectedRoute path={Path.ContributionHistory} component={ContributionHistory} />
                <ProtectedRoute path={Path.ManageAccounts} component={ManageAccounts} />
                <ProtectedRoute path={Path.ContributionDetails} component={ContributionDetails} />
                <ProtectedRoute path={Path.ContributionSchedulePayment} component={ContributionSchedulePayment} />
                <ProtectedRoute path={Path.ContributionCancelPayment} component={ContributionCancelPayment} />
                <ProtectedRoute path={Path.ContactUs} component={ContactUs} />
                <Route path={Path.Logout} component={Logout} />
                <Route component={PageNotFound} />
            </Switch>
        </Layout>
        </>
    )
};

function mapStateToProps(state: AppState) {
    const { pathname } = state.router.location;
    return {
        pathname,
        dcr: state.dcr,
        helper: state.helper
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    const { goToContributionHistory, isSessionAvailable,fetchAllConfiguration } = helperActionCreators;
    return bindActionCreators({ goToContributionHistory, isSessionAvailable,fetchAllConfiguration }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);